var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLabelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.4138 17L18 4.58624C17.815 4.39972 17.5947 4.25184 17.352 4.15119C17.1093 4.05055 16.849 3.99916 16.5863 3.99999H5.00001C4.73479 3.99999 4.48044 4.10535 4.2929 4.29289C4.10537 4.48042 4.00001 4.73478 4.00001 4.99999V16.5862C3.99917 16.849 4.05057 17.1093 4.15121 17.352C4.25185 17.5947 4.39973 17.815 4.58626 18L17 30.4137C17.1857 30.5995 17.4062 30.7469 17.6489 30.8474C17.8916 30.9479 18.1517 30.9997 18.4144 30.9997C18.6771 30.9997 18.9372 30.9479 19.1799 30.8474C19.4225 30.7469 19.643 30.5995 19.8288 30.4137L30.4138 19.8287C30.5995 19.643 30.7469 19.4225 30.8474 19.1798C30.948 18.9372 30.9997 18.6771 30.9997 18.4144C30.9997 18.1517 30.948 17.8916 30.8474 17.6489C30.7469 17.4062 30.5995 17.1857 30.4138 17ZM18.4138 29L6.00001 16.5862V5.99999H16.5863L29 18.4137L18.4138 29ZM12 10.5C12 10.7967 11.912 11.0867 11.7472 11.3333C11.5824 11.58 11.3481 11.7723 11.074 11.8858C10.7999 11.9993 10.4983 12.0291 10.2074 11.9712C9.9164 11.9133 9.64913 11.7704 9.43935 11.5607C9.22957 11.3509 9.08671 11.0836 9.02883 10.7926C8.97095 10.5017 9.00066 10.2001 9.11419 9.92597C9.22772 9.65188 9.41998 9.41761 9.66666 9.25279C9.91333 9.08797 10.2033 8.99999 10.5 8.99999C10.8978 8.99999 11.2794 9.15803 11.5607 9.43933C11.842 9.72064 12 10.1022 12 10.5Z",
    fill: "#FF7A00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabelIcon);
export default __webpack_public_path__ + "static/media/label-icon.b844764793ffad80cbd5b5d64df204c7.svg";
export { ForwardRef as ReactComponent };